import React, { useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const INITIAL_ITEMS = [{
  src: 'https://cdn.magicpatterns.com/uploads/nddNKvKyZrrfmr6ZSmc5tm/Captura_de_pantalla_2026-03-11_133321.png',
  label: 'Empanadas artesanales'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sUCfA7aDShZurg1hWZarrw/Captura_de_pantalla_2026-03-11_133340.png',
  label: 'Torta de fiambre'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eEfHwBh55Xn4C6MoycShbL/Captura_de_pantalla_2026-03-11_133354.png',
  label: 'Sándwiches de miga'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aXzbx1Lt1HZhuC9BF8Y2eB/Captura_de_pantalla_2026-03-11_133428.png',
  label: 'Sándwiches Olímpicos'
}];
const EXTRA_ITEMS = [{
  src: 'https://cdn.magicpatterns.com/uploads/hNm5rE29HYkp21QAaP4sHt/Captura_de_pantalla_2026-03-11_133401.png',
  label: 'Canapés variados'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1WXxWg3uM4XfQayhyXCnkp/Captura_de_pantalla_2026-03-11_133441.png',
  label: 'Picada artesanal'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.7,
      ease: [0.21, 0.47, 0.32, 0.98]
    }
  }
};
export function FoodGallerySection() {
  const [showMore, setShowMore] = useState(false);
  return <section className="py-20 bg-cream relative overflow-hidden" data-id="element-133">
      {/* Subtle warm radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-134"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-136">
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-137">
            <div className="h-[1px] w-10 bg-gold/50" data-id="element-138"></div>
            <span className="text-gold font-medium tracking-[0.2em] text-xs uppercase" data-id="element-139">
              Nuestra Producción
            </span>
            <div className="h-[1px] w-10 bg-gold/50" data-id="element-140"></div>
          </div>
          <h2 className="text-3xl md:text-4xl font-serif text-deep-brown" data-id="element-141">
            Elaborado a mano, cada día
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} className="grid grid-cols-2 gap-4 md:gap-6 auto-rows-[220px] md:auto-rows-[320px]" data-id="element-142">
          {INITIAL_ITEMS.map((item, index) => <motion.div key={index} variants={itemVariants} className="relative group rounded-md overflow-hidden" data-id="element-143">
              <div className="absolute inset-0 bg-linen" data-id="element-144"></div>
              <img src={item.src} alt={item.label} className="absolute inset-0 w-full h-full object-cover sepia-[0.15] saturate-[1.1] brightness-[1.02] contrast-[1.02]" data-id="element-145" />
              <div className="absolute inset-0 bg-gradient-to-t from-deep-brown/50 via-transparent to-sand/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-146"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" data-id="element-147">
                <span className="text-white font-medium text-sm tracking-wide drop-shadow-lg" data-id="element-148">
                  {item.label}
                </span>
              </div>
              <div className="absolute inset-0 rounded-md ring-1 ring-inset ring-sand/40 pointer-events-none" data-id="element-149"></div>
            </motion.div>)}
        </motion.div>

        {/* Extra photos with animation */}
        <AnimatePresence data-id="element-150">
          {showMore && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.5,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="overflow-hidden" data-id="element-151">
              <motion.div variants={containerVariants} initial="hidden" animate="visible" className="grid grid-cols-2 gap-4 md:gap-6 auto-rows-[220px] md:auto-rows-[320px] mt-4 md:mt-6" data-id="element-152">
                {EXTRA_ITEMS.map((item, index) => <motion.div key={index} variants={itemVariants} className="relative group rounded-md overflow-hidden" data-id="element-153">
                    <div className="absolute inset-0 bg-linen" data-id="element-154"></div>
                    <img src={item.src} alt={item.label} className="absolute inset-0 w-full h-full object-cover sepia-[0.15] saturate-[1.1] brightness-[1.02] contrast-[1.02]" data-id="element-155" />
                    <div className="absolute inset-0 bg-gradient-to-t from-deep-brown/50 via-transparent to-sand/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-156"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" data-id="element-157">
                      <span className="text-white font-medium text-sm tracking-wide drop-shadow-lg" data-id="element-158">
                        {item.label}
                      </span>
                    </div>
                    <div className="absolute inset-0 rounded-md ring-1 ring-inset ring-sand/40 pointer-events-none" data-id="element-159"></div>
                  </motion.div>)}
              </motion.div>
            </motion.div>}
        </AnimatePresence>

        {/* Ver más / Ver menos button */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center mt-10" data-id="element-160">
          <button onClick={() => setShowMore(!showMore)} className="border border-deep-brown/20 hover:border-terracotta text-deep-brown hover:text-terracotta px-8 py-3 rounded-sm font-medium transition-all duration-300 text-sm tracking-wide" data-id="element-161">
            {showMore ? 'Ver menos' : 'Ver más fotos'}
          </button>
        </motion.div>
      </div>
    </section>;
}